import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bug, Lightbulb, Send, MessageSquare, CheckCircle2, Clock } from "lucide-react";
import Btn from "../components/Btn";
import api, { apiErr } from "../lib/api";

export default function Feedback() {
  const [type, setType] = useState("bug");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState([]);

  const load = () => api.get("/feedback/mine").then(({ data }) => setItems(data.feedback)).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (title.trim().length < 3 || message.trim().length < 5) { toast.error("Judul & pesan terlalu pendek"); return; }
    setBusy(true);
    try {
      await api.post("/feedback", { type, title: title.trim(), message: message.trim() });
      toast.success("Laporan terkirim! Admin akan menindaklanjuti.");
      setTitle(""); setMessage(""); load();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="font-heading font-bold text-2xl sm:text-3xl flex items-center gap-2"><MessageSquare className="w-7 h-7 text-su-primary" /> Saran & Lapor Bug</h1>
        <p className="text-su-muted">Bantu kami jadi lebih baik. Laporanmu langsung sampai ke admin.</p>
      </div>

      <div className="card-chunky p-6">
        <div className="flex gap-2 mb-4">
          <button data-testid="fb-type-bug" onClick={() => setType("bug")}
            className={`flex-1 py-2.5 rounded-xl font-heading font-bold border transition-colors ${type === "bug" ? "bg-su-danger/15 border-su-danger text-su-danger" : "border-su-border text-su-muted"}`}>
            <Bug className="w-4 h-4 inline mr-1" /> Lapor Bug
          </button>
          <button data-testid="fb-type-suggestion" onClick={() => setType("suggestion")}
            className={`flex-1 py-2.5 rounded-xl font-heading font-bold border transition-colors ${type === "suggestion" ? "bg-su-energy/15 border-su-energy text-su-energy" : "border-su-border text-su-muted"}`}>
            <Lightbulb className="w-4 h-4 inline mr-1" /> Saran
          </button>
        </div>
        <input data-testid="fb-title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Judul singkat" maxLength={120}
          className="w-full px-4 py-3 rounded-xl border border-su-border bg-su-bg outline-none focus:border-su-primary mb-3" />
        <textarea data-testid="fb-message" value={message} onChange={(e) => setMessage(e.target.value)} rows={4} placeholder="Jelaskan detailnya..." maxLength={2000}
          className="w-full px-4 py-3 rounded-xl border border-su-border bg-su-bg outline-none focus:border-su-primary mb-4 resize-none" />
        <Btn data-testid="fb-submit" onClick={submit} disabled={busy} className="w-full"><Send className="w-4 h-4" /> {busy ? "Mengirim..." : "Kirim"}</Btn>
      </div>

      <div>
        <h2 className="font-heading font-bold text-lg mb-3">Riwayat Laporanmu</h2>
        {items.length === 0 ? <p className="text-su-muted text-sm">Belum ada laporan.</p> : (
          <div className="space-y-3">
            {items.map((f) => (
              <div key={f.id} className="card-chunky p-4" data-testid={`fb-item-${f.id}`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-[10px] font-heading font-bold uppercase px-2 py-0.5 rounded ${f.type === "bug" ? "bg-su-danger/15 text-su-danger" : "bg-su-energy/15 text-su-energy"}`}>{f.type === "bug" ? "Bug" : "Saran"}</span>
                  <span className="font-heading font-bold flex-1 truncate">{f.title}</span>
                  {f.reply ? <span className="text-xs text-su-success font-bold flex items-center gap-1"><CheckCircle2 className="w-3.5 h-3.5" /> Dibalas</span>
                    : <span className="text-xs text-su-muted font-bold flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> Menunggu</span>}
                </div>
                <p className="text-sm text-su-muted">{f.message}</p>
                {f.reply && (
                  <div className="mt-3 rounded-xl bg-su-primary/10 border border-su-primary/30 p-3">
                    <p className="text-xs font-heading font-bold text-su-primary mb-1">Balasan Admin</p>
                    <p className="text-sm">{f.reply}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
